import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";

// Styles
import defaultClasses from "./googleMapsButton.module.scss";
import { mergeClasses } from "@magento/venia-ui/lib/classify";

//Components
import Image from "../../overrides/venia-ui/components/Image";
import Icon from "../Icon";

//Assets
import bg from "../../assets/images/googlemaps.png";
import logo from "../../assets/images/miscusi_logo_mobile.svg";
import LinkBetween from "../LinkBetween/LinkBetween";
import { useIntl } from "react-intl";
import { bgImage } from "@Src_main/utils/generalUtils";
const DEFAULT_STYLE = {
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center"
};
const GoogleMapsButton = props => {
  const {
    link,
    onlyTakeaway,
    text
  } = props;
  const {
    formatMessage
  } = useIntl();
  const classes = mergeClasses(defaultClasses);
  if (onlyTakeaway) {
    return /*#__PURE__*/React.createElement(LinkBetween, {
      toTakeAway: true,
      href: "/",
      className: "component-button-image uk-flex uk-flex-middle uk-flex-center ".concat(classes.googleMapsButton),
      style: _objectSpread(_objectSpread({}, DEFAULT_STYLE), {
        backgroundImage: bgImage(bg)
      })
    }, /*#__PURE__*/React.createElement("div", {
      toTakeAway: true,
      href: "/",
      className: "uk-flex uk-flex-middle box-takeaway ".concat(classes.boxTakeaway)
    }, /*#__PURE__*/React.createElement("div", {
      className: "uk-flex uk-flex-column info ".concat(classes.info)
    }, /*#__PURE__*/React.createElement("div", {
      className: "title ".concat(classes.title)
    }, "APERTO - TAKE AWAY"), /*#__PURE__*/React.createElement("div", {
      className: "description ".concat(classes.description)
    }, "Per ora il ristorante \xE8 chiuso")), /*#__PURE__*/React.createElement("div", {
      className: "icon ".concat(classes.icon)
    }, /*#__PURE__*/React.createElement(Icon, {
      color: "red",
      name: "icon-arrow-right"
    }))));
  }
  return /*#__PURE__*/React.createElement("a", {
    href: link,
    target: "_blank",
    className: "component-button-image uk-flex uk-flex-middle uk-flex-center ".concat(classes.googleMapsButton),
    style: _objectSpread(_objectSpread({}, DEFAULT_STYLE), {
      backgroundImage: bgImage(bg)
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "uk-text-uppercase text ".concat(classes.text)
  }, text ? text : formatMessage({
    id: "button.google.maps"
  })), /*#__PURE__*/React.createElement("div", {
    className: "link ".concat(classes.link)
  }, /*#__PURE__*/React.createElement(Image, {
    alt: "Miscusi",
    height: 48,
    src: logo,
    title: "Miscusi",
    width: 48,
    displayPlaceholder: false
  })));
};
export default GoogleMapsButton;